module.exports = {
  controller: require('./salon-main-screen-details.ctrl')
  template: require('./salon-main-screen-details.pug')()
  bindings:
    salon: '<'
    onSubmit: '&'
}
